export const phoneNumberInsert = (previousValue, value) => {
    let index = 0;
    if(!previousValue  || !value) return value;
    if(value.length > 4) {
        while ((index < previousValue.length) && (previousValue[index] == value[index])) {
            index++;
        }
    }
    if(!value[index] || value[index] == " ")
        return value;
    if(!previousValue[index] || previousValue[index] == " ")
        return value;
    if((value.length <= 12 && previousValue.length <= 12) && (value.length < previousValue.length))
        return value;
    if((value.length > 4) && (index < previousValue.length))
        return value.substring(0, index + 1) + previousValue.substring(index);
}
